<button class="btn-shared">
    <ng-content></ng-content>
</button>
